import { message } from 'antd'

export function tryEditForm(editingFormData: any, warningMessage?: string) {
  if (editingFormData) {
    warningMessage && message.warning(warningMessage)
    return true
  }
  return false
}
